export default __webpack_public_path__ + "static/media/dummy-image.ebf9949d.png";